<template>
  <div>
    <section class="mb-4 mb-lg-5">
      <div class="container">
        <div class="image-header" :style="coverImage">
          <label for="cover" class="btn btn-outline-color2">Adicionar imagem</label>
          <input
            type="file"
            name="cover"
            id="cover"
            style="display: none"
            @change="changeCover"
            accept="image/*"
          />
        </div>
        <p class="font-size-xSmall mt-2 text-color2 mb-0 text-center text-lg-left">Tamanho ideal: 1110px x 350px</p>
      </div>
    </section>
    <CropperModal
      :src="cropSrc"
      @cropped="setCover"
    />
    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
            <div class="form-group mb-4">
              <input
                type="text"
                class="form-control font-weight-bold font-size-medium bordered-bottom"
                name="name"
                placeholder="Título"
                v-model.trim="$v.book.title.$model"
                @blur="setSlug"
              />
            </div>
            <div class="form-group mb-4 col-md-8 mx-md-auto editable-form">
              <span class="font-size-small">{{ baseUrl }}/{{ user ? user.username : 'username' }}/b/</span>
              <input
                type="text"
                class="form-control bordered-bottom font-size-small pb-0 text-left font-weight-bold text-color2"
                name="slug"
                placeholder="URL"
                v-model.trim="$v.book.slug.$model"
              />
            </div>
            <div class="form-group mb-5 col-md-6 mx-md-auto">
              <textarea
                class="form-control bordered-bottom font-size-small w-100"
                name="description"
                placeholder="Escreva aqui uma sinopse para seu livro"
                v-model.trim="book.description"
              ></textarea>
              <p class="font-size-small text-right">
                <span
                  class="d-inline-block"
                  :class="{
                    'text-color4': book.description.length > 700
                  }"
                >
                  {{ book.description.length }}
                </span>/700
              </p>
              <p
                class="font-size-xSmall mt-2 text-color2 mb-0 text-center"
              >
                A sinopse é importante para que seus leitores saibam qual o assunto do seu livro. Caso você não tiver uma sinopse pronta, você pode deixar esta área em branco e depois editá-la.
              </p>
            </div>
            <div class="form-group mb-4">
              <label class="font-size-medium font-weight-bold d-block mb-3">
                Categoria
                <i
                  class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                  v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                  :title="this.categoryTooltipText"
                  >
                </i>
              </label>
              <p
                class="font-size-small"
                v-if="!book.category_id && !selectedCategory"
              >
                Sem categoria selecionada
              </p>
              <template v-else>
                <div class="mb-4 col-md-4 mx-md-auto">
                  <Loader
                    color="color2"
                    size="medium"
                    v-if="selectedCategory === 'loading'"
                  />
                  <div
                    class="d-flex align-items-center category-item rounded-regular"
                    v-else-if="selectedCategory"
                  >
                    <div
                      class="image rounded-regular background-cover shadow-light"
                      :style="{ backgroundImage: `url('${selectedCategory.cover}')` }"
                    ></div>
                    <div class="content pl-2 d-flex align-items-center">
                      <span class="font-size-small">{{ selectedCategory.name }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <Button
                class="btn-sm btn-outline-color2"
                v-b-modal.select-category
              >
                Selecionar categoria
              </Button>
              <SelectCategoryModal
                @category-selected="selectCategory"
              />
            </div>
            <div class="form-group mb-4">
              <label class="font-size-medium font-weight-bold d-block mb-3">Privacidade</label>
              <DropdownSelect
                v-model.trim="$v.book.visibility.$model"
                :options="visibilityOptions"
                size="xSmall"
              />
              <p
                class="font-size-xSmall mt-2 text-color2 mb-0 text-center"
              >
                Dica: {{ visibilityTipText }}
              </p>
            </div>
            <!-- LICENSE -->
            <div class="form-group mb-4">
              <label class="font-size-medium font-weight-bold d-block mb-3">
                Licença
                <i
                  class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                  v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                  :title="licenseTooltipText"
                ></i>
              </label>
              <DropdownSelect
                v-model.trim="$v.book.license.$model"
                :options="licenseOptions"
                size="xSmall"
              />
              <p
                class="font-size-xSmall mt-2 text-color2 mb-0 text-center col-md-8 mx-md-auto"
              >
                Dica: {{ licenseTipText }}
              </p>
            </div><!-- END LICENSE -->
            <!-- GÊNEROS -->
            <div class="form-group mb-4">
              <div class="col-md-4 mx-md-auto">
                <label class="font-size-medium font-weight-bold d-block">Gêneros</label>
                <div
                  v-if="genres === 'loading'"
                >
                  <Loader
                    color="color2"
                    size="medium"
                  />
                </div>
                <Select2
                  :options="genresAvailable"
                  @input="storeGenre"
                  :forgettable="true"
                  placeholder="Selecione ou digite o gênero"
                  v-else
                />
              </div>
              <div
                class="col-md-6 mx-md-auto"
                v-if="book.genres.length > 0"
              >
                <ul
                  class="tag-list d-flex mt-4 flex-wrap justify-content-center"
                >
                  <li
                    class="tag-item mb-3 mr-4 font-size-regular"
                    v-for="(genre, index) in selectedGenres"
                    :key="genre.id"
                  >
                    <span class="tag">{{ genre.name }}</span>
                    <button
                      type="button"
                      class="remove-tag"
                      @click="removeGenre(genre, index)"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div> <!-- END GÊNEROS -->
            <!-- TAGS -->
            <div class="form-group mb-4">
              <div class="col-md-4 mx-md-auto">
                <label class="font-size-medium font-weight-bold d-block">
                  Tags
                  <i
                    class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                    v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                    :title="this.tagsTooltipText"
                    >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control bordered-bottom font-size-small pb-0 px-0 w-100"
                  name="tag"
                  placeholder="Separe tags com enter ou vírgula"
                  v-model="tag"
                  @keyup.enter.188.prevent="storeTag"
                />
              </div>
              <div
                class="col-md-6 mx-md-auto"
                v-if="book.tags.length > 0"
              >
                <ul
                  class="tag-list d-flex mt-4 flex-wrap justify-content-center"
                >
                  <li
                    class="tag-item mb-3 mr-4 font-size-regular"
                    v-for="(tag, index) in book.tags"
                    :key="index"
                  >
                    <span class="tag">{{ tag }}</span>
                    <button
                      type="button"
                      class="remove-tag"
                      @click="removeTag(tag, index)"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div> <!-- END TAGS -->
          <!-- NUMBER OF PAGES -->
          <div class="form-group mb-4">
            <div class="col-md-4 mx-md-auto">
              <label class="font-size-medium font-weight-bold d-block">
                Número de páginas
                <i
                  class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                  v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                  title="Campo voltado para livros em PDF."
                >
                </i>
              </label>
              <input
                type="text"
                class="form-control bordered-bottom font-size-small pb-0 px-0 w-100"
                name="tag"
                placeholder="Digite o número de páginas"
                v-model.trim="book.number_of_pages"
              />
            </div>
          </div> <!-- END NUMBER OF PAGES -->
            <!-- AMOUNT -->
            <div class="form-group mb-4" v-if="1 == 2">
              <div class="col-md-8 mx-md-auto">
                <label class="font-size-medium font-weight-bold d-block">Digite o preço do livro</label>
              </div>
              <!-- RECEIVABLE CONFIGURATION WRAPPER -->
              <div
                class="receivable-conf"
                v-if="user && !user.is_receivable_configured"
              >
                <div class="mx-auto col-md-6">
                  <div>
                    <BaseIcon
                      size="medium"
                    >
                      <LockIcon />
                    </BaseIcon>
                  </div>
                  <h2 class="font-weight-bold font-size-regular text-color2">Quase lá!</h2>
                  <p class="font-size-small">Precisamos de mais algumas informações para habilitar a funcionalidade de venda!</p>
                  <Button
                    class="btn-sm btn-outline-color2 px-3 mb-3"
                    v-b-modal.user-receivable-info
                  >
                    Preencher informações
                  </Button>
                  <p class="font-size-small mb-md-0">Caso o livro seja gratuito, pode seguir normalmente.</p>
                </div>
                <UserReceivableInfoModal
                  @receivable-created="parseReceivable"
                />
              </div> <!-- END RECEIVABLE CONFIGURATION WRAPPER -->
              <!-- PRICE WRAPPER -->
              <div v-else-if="user && user.is_receivable_configured">
                <!-- PENDING STATUS -->
                <template v-if="user.recipient_status === 'registration'">
                  <div class="mx-auto col-md-6">
                    <div>
                      <BaseIcon
                        size="medium"
                      >
                        <LockIcon />
                      </BaseIcon>
                    </div>
                    <h2 class="font-weight-bold font-size-regular text-color2">Quase lá!</h2>
                    <p class="font-size-small">Estamos credenciando seu cadastro de recebedor junto do nosso parceiro de processamento de pagamentos e em breve você receberá uma confirmação por email!</p>
                  </div>
                </template><!-- END PENDINT STATUS -->
                <!-- REFUSED STATUS -->
                <template v-else-if="user.recipient_status === 'refused'">
                  <div class="mx-auto col-md-6">
                    <div>
                      <BaseIcon
                        size="medium"
                      >
                        <LockIcon />
                      </BaseIcon>
                    </div>
                    <h2 class="font-weight-bold font-size-regular text-color2">Cadastro recusado</h2>
                    <p class="font-size-small">Infelizmente seu cadastro como recebedor foi recusado pelo nosso parceiro de processamento de pagamentos.</p>
                    <p class="font-size-small">Mas não se desespere que ainda é possível recorrermos da decisão. Para isso, pedimos que você entre em contato conosco pelo email <span class="font-weight-bold text-color2">time@scriv.com.br</span> ou pelas nossas redes sociais que nossa equipe te ajudará no processo.</p>
                  </div>
                </template><!-- END REFUSED STATUS -->
                <!-- ACTIVE STATUS -->
                <template v-else-if="user.recipient_status === 'active'">
                  <div class="col-md-4 mx-md-auto">
                    <Money
                      class="form-control bordered-bottom font-size-regular font-weight-bold text-color2 pb-0 px-0 w-100"
                      v-model="book.amount"
                      v-bind="money"
                      :disabled="!user || !user.is_receivable_configured"
                    />
                  </div>
                  <div class="col-md-6 mx-md-auto">
                    <p class="font-size-xSmall mt-2 text-center text-color2 mb-0" v-if="book.amount > 9999">Valor máximo de: R$ 9999,00</p>
                    <p class="font-size-xSmall mt-2 mb-0 text-center">Livros sem valor serão acessíveis gratuitamente</p>
                    <p
                      class="font-size-xSmall text-center"
                      v-if="book.amount > 0 && book.amount < parsedMinimumBookAmount && user"
                    >
                      O valor mínimo é de <strong>{{ parsedMinimumBookAmount | formatMoney }}</strong>
                    </p>
                    <p class="mt-2 mb-0 text-center">
                      <router-link
                        class="font-size-xSmall text-color2 text-decoration-underline"
                        target="_blank"
                        :to="{ name: 'statics.wallet' }"
                      >
                        Entenda as nossas taxas e como elas são cobradas
                      </router-link>
                    </p>
                    <div
                      class="text-center mt-3 font-size-small"
                      v-if="book.amount > 0 && user"
                    >
                      <p>
                        <strong>Valor cobrado:</strong> {{ book.amount | formatMoney }}<br/>
                        <strong>Taxa Scriv:</strong>
                          {{ scrivFee }}%
                          <span
                            id="tooltip-fees"
                            class="text-color2"
                            style="cursor:pointer;"
                            >
                              <i class="fa fa-info-circle"></i>
                          </span>
                          <b-tooltip custom-class="font-size-xSmall" target="tooltip-fees" triggers="hover">
                            <p>As taxas retidas representam {{ (book.amount * scrivFee / 100) | formatMoney }} do valor total de {{ book.amount | formatMoney }}.</p>
                            <p>Neste valor estão inclusos os custos de impostos, transações financeiras, anti-fraude para pagamentos e toda a operação da Scriv (equipe, servidores, custos administrativos e jurídicos).</p>
                            <p>Para mais informações, acesse a página <router-link class="font-weight-bold" target="_blank" :to="{ name: 'statics.wallet' }" style="color: #EA6C54 !important;">Scriv Wallet</router-link>.</p>
                          </b-tooltip>
                          <br/>
                        <strong>Valor líquido a receber:</strong> {{ (book.amount * (user.partner_group.split / 100 / 100)) | formatMoney }}
                      </p>
                      <p>
                        <strong>Opções de pagamento disponíveis</strong><br/>
                        <span class="d-block">Cartão de crédito</span>
                        <span class="d-block">
                          <span
                            :class="{
                            'text-strike': book.amount < minimumAmountForBoleto
                            }"
                            >
                            Boleto bancário
                          </span>
                          <i
                            class="fa fa-info-circle cursor-pointer text-color2 font-size-small"
                            v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                            :title="`A opção de boleto ficará disponível a partir de ${ $options.filters.formatMoney(minimumAmountForBoleto) }`"
                            >
                          </i>
                        </span>
                        <span class="d-block">PIX</span>
                      </p>
                    </div>
                  </div>
                </template><!-- END ACTIVE STATUS -->
              </div> <!-- END PRICE WRAPPER -->
            </div><!-- END AMOUNT -->
            <div class="mb-4 col-md-8 mx-md-auto">
              <p class="font-size-xSmall mt-2 text-color2 mb-0 text-center"><strong>Atenção:</strong> O livro só aparecerá para os usuários se tiver um capítulo publicado ou arquivo associado. Até lá, apenas você poderá ver, independente da privacidade selecionada.</p>
            </div>
            <div class="form-group mt-5">
              <Button
                class="btn-primary mb-3 mb-md-0"
                type="button"
                :disabled="$v.$invalid || (book.amount > 0 && book.amount < parsedMinimumBookAmount)"
                :loading="loader"
                @click="submit()"
              >
                <template
                  v-if="$route.name === 'books.create'"
                >
                  Criar
                </template>
                <template
                  v-else
                >
                  Salvar
                </template>
              </Button>
              <Button
                class="btn-primary ml-md-3 mb-3 mb-md-0"
                type="button"
                :disabled="$v.$invalid || (book.amount > 0 && book.amount < parsedMinimumBookAmount)"
                :loading="loaderRedirect === 'chapter'"
                v-if="$route.name === 'books.create'"
                @click="submit('chapter')"
              >
                Criar e escrever capítulo
              </Button>
              <Button
                class="btn-primary ml-md-3 mb-3 mb-md-0"
                type="button"
                :disabled="$v.$invalid || (book.amount > 0 && book.amount < parsedMinimumBookAmount)"
                :loading="loaderRedirect === 'file'"
                v-if="$route.name === 'books.create'"
                @click="submit('file')"
              >
                Criar e enviar arquivo
              </Button>
              <router-link
                class="btn btn-outline-color2 ml-md-3"
                :to="'/'"
              >
                Cancelar
              </router-link>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import { required, between } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'
import { slugify, checkIfUserIsOwnerOfEntity } from '@/utils'
import { mapState } from 'vuex'
import BooksService from '@/modules/books/services/books-service'
import CategoriesService from '@/modules/categories/services/categories-service'
import GenresService from '@/modules/genres/services/genres-service'
import UsersService from '@/modules/users/services/users-service'

import Button from '@/components/common/Button/Button.vue'
import DropdownSelect from '@/components/common/Select/DropdownSelect.vue'
import CropperModal from '@/components/common/Cropper/CropperModal'
import Loader from '@/components/common/Loader/Loader.vue'
import { Money } from 'v-money'
import SelectCategoryModal from '@/components/categories/SelectCategoryModal'
import Select2 from '@/components/common/Select/Select2'
import UserReceivableInfoModal from '@/components/user/UserReceivableInfoModal'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import LockIcon from '@/components/common/Icon/LockIcon'

export default {
  mixins: [variables],
  components: {
    BaseIcon,
    Button,
    CropperModal,
    DropdownSelect,
    Loader,
    LockIcon,
    Money,
    SelectCategoryModal,
    Select2,
    UserReceivableInfoModal
  },
  data () {
    return {
      loader: false,
      loaderRedirect: false,
      currentBook: null,
      cropSrc: '',
      book: {
        title: '',
        description: '',
        slug: '',
        visibility: 'public',
        license: 'cc-by-nc-nd',
        category_id: '',
        is_comments_enabled: true,
        tags: [],
        genres: [],
        cover: null,
        status: 'published',
        amount: 0,
        number_of_pages: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      tag: '',
      selectedCategory: null,
      publicationMethod: 'platform',
      genres: []
    }
  },
  metaInfo () {
    return {
      title: this.$route.name === 'books.create' ? 'Criar livro' : 'Editar livro'
    }
  },
  validations () {
    return {
      book: {
        title: { required },
        slug: { required },
        visibility: { required },
        license: { required },
        category_id: { required },
        amount: {
          between: between(0, 9999)
        }
      }
    }
  },
  watch: {
    user (newUser, oldUser) {
      if (!this.currentBook) this.getBook()
    }
  },
  created () {
    if (this.user) this.getBook()
    this.getGenres()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    coverImage () {
      return {
        backgroundImage: this.book.cover ? `url('${URL.createObjectURL(this.book.cover)}')` : `url('${this.currentBook ? this.currentBook.cover : this.noCoverUrl}')`
      }
    },
    cleanSlug () {
      return this.slug
    },
    visibilityTipText () {
      if (this.book.visibility === 'public') return 'qualquer um poderá ver o livro'
      else if (this.book.visibility === 'private') return 'apenas você poderá ver o livro'
      return ''
    },
    licenseTipText () {
      if (!this.book.license) return ''
      const option = this.licenseOptions.find(item => {
        return item.key === this.book.license
      })
      return option.description || ''
    },
    selectedGenres () {
      const genres = this.genres.filter(genre => {
        return this.book.genres.includes(genre.id)
      })

      genres.sort((a, b) => a.name.localeCompare(b.name))

      return genres
    },
    genresAvailable () {
      if (!Array.isArray(this.genres)) return []
      const genres = this.genres.filter(genre => {
        return !this.book.genres.includes(genre.id)
      })

      genres.sort((a, b) => a.name.localeCompare(b.name))

      return genres.map(genre => {
        return {
          label: genre.name,
          code: genre.id
        }
      })
    },
    scrivFee () {
      return this.user ? 100 - (this.user.partner_group.split / 100) : 0
    },
    parsedMinimumBookAmount () {
      return this.minimumBookAmount / 100
    },
    parsedBoletoFee () {
      return this.boletoFee / 100
    },
    minimumAmountForBoleto () {
      return this.user ? (100 * this.parsedBoletoFee) / this.scrivFee : 0
    }
  },
  methods: {
    changeCover (e) {
      const file = e.target.files[0]
      // this.book.cover = file
      this.cropSrc = URL.createObjectURL(file)
    },
    setCover (blob) {
      this.book.cover = blob
    },
    setSlug () {
      if (!this.book.slug) {
        this.book.slug = slugify(this.book.title)
      }
    },
    async submit (destination = '') {
      if (destination) this.loaderRedirect = destination
      else this.loader = true
      try {
        const id = this.currentBook ? this.currentBook.id : null
        const book = await BooksService.post(id, this.book)
        if (destination === 'chapter') this.$router.push({ name: 'chapters.create', params: { bookSlug: book.slug } })
        else if (destination === 'file') this.$router.push({ name: 'books.file.upload', params: { slug: book.slug } })
        else this.$router.push({ name: 'books.show', params: { username: book.user.username, slug: book.slug } })
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
      this.loaderRedirect = false
    },
    async getBook () {
      if (this.$route.name === 'books.edit') {
        try {
          const book = await BooksService.getBook(this.$route.params.slug)
          checkIfUserIsOwnerOfEntity(book, this.user)
          this.setBook(book)
        } catch (error) {
          // If there is an error, redirect to home
          this.$router.push('/')
        }
      }
    },
    storeTag (e) {
      const value = e.target.value.replace(',', '').replaceAll('#', '')
      if (!this.book.tags.includes(value)) {
        this.book.tags.push(value)
      }
      this.tag = ''
    },
    removeTag (tag, index) {
      this.book.tags.splice(index, 1)
    },
    storeGenre (genre) {
      if (!this.book.genres.includes(genre.code)) {
        this.book.genres.push(genre.code)
      }
    },
    removeGenre (genre) {
      const index = this.book.genres.findIndex(id => id === genre.id)
      this.book.genres.splice(index, 1)
    },
    async getGenres () {
      this.genres = 'loading'
      try {
        const genres = await GenresService.getGenres({})
        this.genres = [...genres]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async selectCategory (id) {
      this.selectedCategory = 'loading'
      try {
        const category = await CategoriesService.getCategory(id)
        this.selectedCategory = Object.assign({}, category)
        this.book.category_id = category.id
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.selectedCategory = null
      }
    },
    async parseReceivable () {
      await UsersService.me()
    },
    setBook (book) {
      this.currentBook = book
      this.book.title = book.title
      this.book.slug = book.slug
      this.book.visibility = book.visibility
      this.book.license = book.license ? book.license : 'cc0'
      this.book.description = book.description ? book.description : ''
      this.book.number_of_pages = book.number_of_pages
      this.book.is_comments_enabled = book.is_comments_enabled
      this.book.category_id = book.category ? book.category.id : ''
      this.book.status = book.status
      if (book.category) this.selectCategory(book.category.id)
      this.book.tags = []
      book.tags.forEach(tag => {
        this.book.tags.push(tag.name)
      })
      this.book.genres = []
      book.genres.forEach(genre => {
        this.book.genres.push(genre.id)
      })
      let amount = ''
      if (book.amount !== null) {
        amount = (parseInt(book.amount) / 100)
      }
      this.book.amount = amount
    }
  }
}
</script>

<style lang="scss" scoped>

.tag-item {
  position: relative;

  .remove-tag {
    border: none;
    padding: 0;
    margin: 0;
    background: #fff;
    border-radius: 30px;
    position: absolute;
    top: -10px;
    right: -15px;
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    color: $color4;
    font-size: $font_size_xSmall;
  }
}

.category-item {
  .image {
    width: 60px;
    height: 40px;
  }
  .content {
    flex-grow: 1;
  }
}

.form-control:disabled {
  opacity: 0.6;
}

.disabled-div {
  opacity: 0.1;
  pointer-events: none;
}

</style>
